import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import MainImg from "./Components/MainImg/MainImg";
import Footer from "./Components/Footer/Footer";
import Quality from "./Components/quality/Quality";
import StartPro from "./Components/StartPro/StartPro";
import WhyChoseUs from "./Components/whyChoseus/WhyChoseUs";
import Homepart from "./Components/Homepart/Homepart";
import Services from "./Components/ServiceCard/ServiceCard";
import Service_com from "./Components/ServiceCard/Service_com";
import Reviews from "./Components/Reviews/Reviews";
import FloatingContact from "./Components/contact/Contact";
import Revi from "./Components/Client/client";
import Headers from "./Components/headers/header";
import FAQ from "./Components/FAQ/FAQ";
import CTA from "./Components/CTA/CTA";
import FeatureCards from "./Components/Banner/Banner";
import BlueWarningBanner from "./Components/moving_banner/movBanner";

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    const scrollToId = location.state?.scrollToId;
    if (!scrollToId) return;

    const element = document.getElementById(scrollToId);
    if (!element) return;

    const header = document.querySelector(".sticky_headers");
    const offset = header ? header.offsetHeight : 0;
    const top =
      scrollToId === "home"
        ? 0
        : element.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top, behavior: "smooth" });
    window.history.replaceState({}, document.title, window.location.pathname);
  }, [location]);

  return (
    <div className="App">
      <Headers />
      <MainImg id="home" />
      <BlueWarningBanner/>
      {/* <Homepart/> */}
      <Services id="services" />
      {/* <Quality/> */}

      <WhyChoseUs id="about" />
      <FAQ />
      <CTA />
      <StartPro />
      <FeatureCards/>
      <Revi />

      <Footer />
      <FloatingContact />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* HOME PAGE */}
        <Route path="/" element={<HomePage />} />

        {/* SERVICE DETAIL PAGE */}
        <Route
          path="/service/:id"
          element={
            <div className="App">
              <Headers />
              <Service_com />
              <Footer />
              <FloatingContact />
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
